import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Euro } from "lucide-react";
import { B2bStatsCardProps } from "@/services/organizationsApi";

export function B2bMrrCard({ stats, loading, error }: B2bStatsCardProps) {
  const mrr = stats?.mrr;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">MRR B2B</CardTitle>
        <Euro className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading && (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        )}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {!loading && !error && mrr && (
          <>
            <div className="text-2xl font-bold">
              {mrr.mrr_eur.toFixed(0)} &euro; / mois
            </div>
            <div className="mt-1 text-xs text-muted-foreground">
              {mrr.per_seat_orgs} org. facturées au siège
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
